import { SET_ON_SUBMIT_DETAILS } from "../action";

export function setOnSubmitDetails(errorFields, errorFlag) {
  return (dispatch) => {
    dispatch({
      type: SET_ON_SUBMIT_DETAILS,
      payload: { errorFields, errorFlag },
    });
  };
}
